const bubble16 = (color) => `
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="621.186 747.085 60 60"><g data-name="Group 39"><path d="M621.186 777.085c0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.568-13.432 30-30 30-16.569 0-30-13.432-30-30Z" fill="${color}" fill-rule="evenodd" data-name="Ellipse 1"/><g data-name="Group 8"><path d="M651.186 762.085c-8.271 0-15 5.383-15 12 0 4.362 2.847 8.272 7.5 10.401v7.599l8.01-6.008c8.035-.214 14.49-5.512 14.49-11.992 0-6.617-6.73-12-15-12Zm0 21h-.5l-4 3v-3.626l-.962-.37c-4.033-1.553-6.538-4.62-6.538-8.004 0-4.964 5.383-9 12-9 6.616 0 12 4.036 12 9 0 4.963-5.384 9-12 9Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/><path d="M643.686 769.585h15v3h-15v-3Zm0 6h10.5v3h-10.5v-3Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/></g></g></svg>
`;
export default bubble16;



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble16.js
// module id = null
// module chunks = 